<template>
	<div class="d-flex justify-content-center">
		<div class="login-wid login-p">
			<div class="ftr-1-5 ftw600">
				{{$t('login.login')}}
			</div>
			<div class="mt-3 ftr-1-5 ftw600">
				{{$t('login.welcome')}}
			</div>
			<div class="mt-2">
				{{$t('login.hint')}} 
				<span style="text-decoration: underline;color: #547EC8;" class="clickAct" @click="toService">{{$t('footers.termsofService')}}</span>
				<span>{{$t('login.and')}}</span>
				<span style="text-decoration: underline;color: #547EC8;" class="clickAct" @click="toService">{{$t('login.privacyPolicy')}}</span>
			</div>
			
			
			<!-- 使用Google登入 -->
			<div id="g_id_onload"
			     v-bind:data-client_id="client_id"
			     data-context="signin"
			     data-ux_mode="popup"
			     data-callback="callback"
			     data-nonce=""
			     data-auto_select="true"
			     data-itp_support="true">
			</div>
			
			<div class="g_id_signin mt-3"
			     data-type="standard"
			     data-shape="rectangular"
			     data-theme="outline"
			     data-text="signin_with"
			     data-size="large"
				 data-width="600"
			     data-logo_alignment="center">
			</div>
			<!-- end -->
			

			<!-- <div class="mt-3 border py-2 br8 text-center ftw600 flex alcenter justify-content-center clickAct">
				<img src="../../assets/image/commom/google.png" alt="" class="mr10" style="width: 24px;height: 24px;" />
				{{$t('login.loginMethod',{way:'Google'})}}
			</div> -->
			<div class="mt-3 border py-2 br8 text-center ftw600 flex alcenter justify-content-center clickAct">
				<img src="../../assets/image/commom/facebook.png" alt="" class="mr10"
					style="width: 24px;height: 24px;" />
				<!-- 使用Facebook登入 -->
				{{$t('login.loginMethod',{way:'Facebook'})}}
			</div>
			<div class="mt-3 border py-2 br8 text-center ftw600 flex alcenter justify-content-center clickAct" @click="loginWx()">
				<img src="../../assets/image/commom/wechat.png" alt="" class="mr10" style="width: 24px;height: 24px;" />
				<!-- 使用WeChat登入 -->
				{{$t('login.loginMethod',{way:'WeChat'})}}
			</div>
			<!-- 分割线 -->
			<div class="mt-3 d-flex align-items-center text-center">
				<div class="flex-grow-1 border-top border-gray"></div>
				<span class="px-3 ftr-1-2">{{$t('login.or')}}</span>
				<div class="flex-grow-1 border-top border-gray"></div>
			</div>
			<div>
				{{$t('login.email')}}
			</div>
			<a-input v-model:value="emailNum" :placeholder="$t('login.emailAccount')" class="mt-2"
				style="height: 40px;" />
			<div class="mt-2">
				{{$t('login.password')}}
			</div>
			<a-input-password v-model:value="password" type="password" :placeholder="$t('login.passwordPlaceholder')"
				class="mt-2" style="height: 40px;" />
			<div class="mt-2">
				<a href="#/register?type=forgot&title=edit" class="cl-black">{{$t('login.forgotPassword')}}</a>
				
				
			</div>
			<div class="form-check mt-3">
				<input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="rememberMe">
				<label class="form-check-label" for="flexCheckDefault">
					{{$t('login.rememberMe')}}
				</label>
			</div>
			<button type="button" class="btn btn-dark bg-theme ftw600 mt-4 py-2 cl-black" style="width: 100%;"
				@click="handleLogin">{{$t('login.toLogin')}}</button>
			<div class="text-center mt-3">
				{{$t('login.noAccount')}}<a href="#/register?type=login" class="cl-black">{{$t('login.register')}}</a>
			</div>
		</div>
	</div>
</template>

<script>
	window.callback = function(response) {
	  console.log(response); // 处理 Google 登录返回的数据
	  
	   if (window.vueInstance) {
	      window.vueInstance.handleLoginResponse(response);
	    }
	
	};
	export default {
		data() {
			return {
				emailNum: '',
				password: '',
				rememberMe: false,
				// client_id:'859293346595-i5il0vnvqdutu0jj48c2djlaldnsdrsq.apps.googleusercontent.com',
				client_id:localStorage.getItem('client_id'),
				credential:'',
				captcha_id:''
			}
		},
		mounted() {
			// 页面加载时尝试从 localStorage 读取账号密码
			const savedEmail = localStorage.getItem('savedEmail');
			const savedPassword = localStorage.getItem('savedPassword');
			if (savedEmail && savedPassword) {
				this.emailNum = savedEmail;
				this.password = savedPassword;
				this.rememberMe = true;
			}
			// console.log("--------------this.client_id",this.client_id);
			const script = document.createElement('script');
			script.src = "https://accounts.google.com/gsi/client";
			script.async = true;
			document.head.appendChild(script);
					
			script.onload = () => {
			  console.log('Google API script loaded');
			};
					
			script.onerror = (error) => {
			  console.error('Error loading script', error);
			};
			
			const scriptWx = document.createElement('script');
			scriptWx.src = "http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
			scriptWx.async = true;
			document.head.appendChild(scriptWx);
			
			
			window.vueInstance = this;
			
			
			
			if(this.checkIfMobile()){
				this.$http.api('addons/fastim/api.user/captchaPre', {
					
				}).then(res=>{
					this.captcha_id = res.captcha_id
				})
			}
		},
		methods: {
			toService(){
				this.$router.push('/textTerms')
			},
			toRegistrationInformation(){
				this.$router.push('/registrationInformation')
			},
			loginWx(){
				 var obj = new WxLogin({
				 self_redirect:true,
				 id:"login_container", 
				 appid: "", 
				 scope: "", 
				 redirect_uri: "",
				  state: "",
				 style: "",
				 href: "",
				 onReady: function(isReady){
				        console.log(isReady);
				    }
				 });
			},
			handleLoginResponse(response){
				console.log("===",this.client_id);
				this.credential = response.credential
				this.$http.api('user/thirdLogin', {
					type:'google',
					credential:response.credential
				}).then(res=>{
					localStorage.setItem('account-token', res.access_token)
					localStorage.setItem('access_token_expire', res.access_token_expire)
					
					this.$message.success('登陆成功')
					if(res.userinfo.first_login==1){
						this.toRegistrationInformation()
					}else{
						this.$router.push('/')
					}
					
					
				}).catch(err=>{
					console.log("err==",err);
				})
			},
			
			checkIfMobile() {
			      const userAgent = navigator.userAgent.toLowerCase();
			      // 判断是否为手机端
			      return /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(userAgent);
			    },
			
			handleLogin() {
				if (this.rememberMe) {
					// 勾选记住我，将账号密码存入 localStorage
					localStorage.setItem('savedEmail', this.emailNum);
					localStorage.setItem('savedPassword', this.password);
				} else {
					// 未勾选，清除 localStorage 中的账号密码
					localStorage.removeItem('savedEmail');
					localStorage.removeItem('savedPassword');
				}
				// 这里可以添加实际的登录逻辑
				console.log('执行登录操作，账号：', this.emailNum, '密码：', this.password);
				this.$http.api('user/passwordLogin', {
					email: this.emailNum,
					password: this.password
				}).then(res => {
					console.log("res", res);
					localStorage.setItem('account-token', res.access_token)
					localStorage.setItem('access_token_expire', res.access_token_expire)
					this.$message.success('登陆成功')
					if(res.userinfo.first_login==1){
						this.toRegistrationInformation()
					}else{
						// 获取所有的 cookies
						const cookies = document.cookie.split('; ');
						
						// 设置过期时间为过去的时间（用于删除 cookie）
						const expires = new Date();
						expires.setTime(expires.getTime() - 1);
						
						// 判断是否存在 token
						let tokenExists = false;
						cookies.forEach(cookie => {
						  if (cookie.startsWith('token=')) {
						    tokenExists = true;
						  }
						});
						
						// 如果存在 token，删除它
						if (tokenExists) {
						  document.cookie = `token=; expires=${expires.toUTCString()}; path=/`;
						}
						
						// 存储新的 token
						document.cookie = `token=${localStorage.getItem('account-token')}; expires=${localStorage.getItem('access_token_expire')}; path=/`; // 设置7天后过期ken=${localStorage.getItem('account-token')}`;
						
						if(FastIm){
							FastIm.tokens.fastim_token=localStorage.getItem('account-token')
							FastIm.onMessage('open')
						}
						this.chatLogin()
						this.$router.push('/').then(() => {
							if(!this.checkIfMobile()){
								window.location.reload();
							}
						});
					}
					
				
				}).catch(err => {
					console.log("err", err);
				})
			},
			chatLogin(){
				this.$http.api('addons/fastim/api.user/login', {
					account:this.emailNum,
					captcha: "miratalker",
					captcha_id: this.captcha_id,
					mobile: "",
					password: this.password,
					tab: 0,
					username: this.emailNum
				}).then(res=>{
					console.log("addons/fastim/api.user/login",res);
					localStorage.setItem('userinfo',JSON.stringify(res.userinfo))
					// uni.setStorageSync('userinfo', res.data.userinfo);
					// this.ws.init(res.userinfo.token, res.userinfo.auth_token)
				})
			}
		}
	}
</script>

<style scoped>
	.login-wid {
		width: 400px;
		padding-top: 70px;
	}

	@media (max-width:576px) {
		.login-wid {
			width: 100%;
			padding-top: 16px;
		}

		.login-p {
			padding: 16px 40px;
		}
	}
	::v-deep.g_id_signin .nsm7Bb-HzV7m-LgbsSe{
		border: 1px solid #000 !important;
		border-radius: 8px !important;
		width: 398px !important;
	}
</style>